import styles from "./Connection.module.css";
import WelcomePage from "../WelcomePage/WelcomePage";
import AddConnectionsPre from "./AddConnectionsPre";
import MyConnectionsPre from "./MyConnectionsPre";
import ToMeRequestsPre from "./ToMeRequestsPre";
import FromMeRequestsPre from "./FromMeRequestsPre";

function ConnectiontSelect() {
  return (
    <>
      <div className={styles.wrapper} />
      <div className={styles.top}>
        <h2 className={styles.header} style={{ marginLeft: 50 }}>
          Connections Options Selection
        </h2>
        <div> &emsp;</div>

        <div> &emsp;</div>
        <div>
          <label
            className={styles.forh3}
            style={{ marginLeft: 50, fontWeight: 550 }}
          >
            Options
          </label>
        </div>
        <div> &emsp;</div>

        <a href="MyConnectionsPre" style={{ marginLeft: 50 }}>
          My connections
        </a>
        <div> &emsp;</div>
        <a href="AddConnectionsPre" style={{ marginLeft: 50 }}>
          Add connections
        </a>
        <div> &emsp;</div>
        <a href="FromMeRequestsPre" style={{ marginLeft: 50 }}>
          Connections I've requested
        </a>
        <div> &emsp;</div>
        <a href="ToMeRequestsPre" style={{ marginLeft: 50 }}>
          Connections requested of me
        </a>
        <div> &emsp;</div>

        <div>
          <a href="WelcomePage">
            <button className={styles.userButtons} style={{ marginLeft: 28 }}>
              Close
            </button>
          </a>
        </div>
      </div>
    </>
  );
}

export default ConnectiontSelect;
